'use client'

import { useTranslation } from '../../context/ConfigContext'
import FormattedPrice from '../FormattedPrice/FormattedPrice'

const ProductConfigurationPrice = ({
  product,
  isStartingPrice = false,
  isCustomPrice = false,
}: {
  product: Product | VariantProduct
  isStartingPrice?: boolean
  isCustomPrice?: boolean
}) => {
  const t = useTranslation()

  return (
    <div>
      <p className='price'>
        {isStartingPrice && <span className='extra'>{t('As low as', {}, true)}</span>}
        {isCustomPrice ? (
          t('Price on demand', {}, false)
        ) : (
          <FormattedPrice
            price={product.price_range.minimum_price.regular_price.value}
            currency={product.price_range.minimum_price.regular_price.currency}
          />
        )}
      </p>
    </div>
  )
}

export const getPriceOfSelectedVariantsForBundle = (
  selectedVariants: Array<Variant | null> | null,
) => {
  if (!selectedVariants) {
    return 0
  }

  const [myMoveVariant, braceletMyMoveVariant] = selectedVariants

  if (!myMoveVariant || !braceletMyMoveVariant) {
    return 0
  }

  const priceMyMove = myMoveVariant.product?.price_range?.minimum_price?.regular_price?.value ?? 0
  const priceBraceletMyMove =
    braceletMyMoveVariant.product?.price_range?.minimum_price?.regular_price?.value ?? 0

  const totalPrice = priceMyMove + priceBraceletMyMove

  return totalPrice
}

export const ProductConfigurationPriceBundleProduct = ({
  product,
  selectedVariants,
}: {
  product: Product
  selectedVariants: Array<Variant | null> | null
}) => {
  if (!selectedVariants) {
    return <ProductConfigurationPrice product={product} isStartingPrice />
  }

  const price = getPriceOfSelectedVariantsForBundle(selectedVariants)

  if (!price) {
    return <ProductConfigurationPrice product={product} isStartingPrice />
  }

  return (
    <p className='price'>
      <FormattedPrice
        price={price}
        currency={product.price_range.minimum_price.regular_price.currency}
      />
    </p>
  )
}

export default ProductConfigurationPrice
